import api from './axios';

export const usersAPI = {
  /**
   * GET /api/admin/users
   * @param {Object} params - search, gender, from, to, page, per_page
   */
  getList: (params = {}) => api.get('/admin/users', { params }),

  /**
   * GET /api/admin/users/{id}
   */
  getById: (id) => api.get(`/admin/users/${id}`),

  /**
   * POST /api/admin/users/{id}/profit
   * @param {number} id
   * @param {{ type: 'amount'|'percentage', value: number, note?: string }} payload
   */
  addProfit: (id, payload) => api.post(`/admin/users/${id}/profit`, payload),
};
